import React from "react";

const SaveAndSendSvg = ({ disabled = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <g clip-path="url(#clip0_9570_143041)">
        <path
          d="M21.6667 4.33301C22.2133 4.33283 22.7398 4.53928 23.1406 4.91096C23.5414 5.28264 23.7869 5.79209 23.8279 6.33717L23.8333 6.49967V19.4997C23.8335 20.0463 23.6271 20.5728 23.2554 20.9736C22.8837 21.3744 22.3743 21.6199 21.8292 21.6609L21.6667 21.6663H4.33333C3.78671 21.6665 3.26022 21.4601 2.85941 21.0884C2.45859 20.7167 2.21308 20.2073 2.17208 19.6622L2.16667 19.4997V18.4163H4.33333V19.4997H21.6667V8.03151L14.1483 15.5498C13.864 15.8342 13.4843 16.003 13.0827 16.0236C12.6811 16.0442 12.2861 15.9151 11.9741 15.6614L11.8506 15.5498L4.33333 8.03151V8.66634H2.16667V6.49967C2.16649 5.95305 2.37294 5.42656 2.74462 5.02575C3.1163 4.62493 3.62575 4.37942 4.17083 4.33842L4.33333 4.33301H21.6667ZM6.5 14.083C6.78732 14.083 7.06287 14.1971 7.26603 14.4003C7.4692 14.6035 7.58333 14.879 7.58333 15.1663C7.58333 15.4537 7.4692 15.7292 7.26603 15.9324C7.06287 16.1355 6.78732 16.2497 6.5 16.2497H1.08333C0.796015 16.2497 0.520465 16.1355 0.317301 15.9324C0.114137 15.7292 0 15.4537 0 15.1663C0 14.879 0.114137 14.6035 0.317301 14.4003C0.520465 14.1971 0.796015 14.083 1.08333 14.083H6.5ZM20.1348 6.49967H5.86517L13 13.6345L20.1348 6.49967ZM5.41667 10.833C5.69279 10.8333 5.95837 10.939 6.15915 11.1286C6.35993 11.3181 6.48075 11.5772 6.49694 11.8529C6.51312 12.1285 6.42344 12.3999 6.24621 12.6117C6.06899 12.8234 5.8176 12.9595 5.54342 12.9921L5.41667 12.9997H2.16667C1.89055 12.9994 1.62496 12.8936 1.42418 12.7041C1.2234 12.5145 1.10258 12.2555 1.0864 11.9798C1.07021 11.7042 1.1599 11.4328 1.33712 11.221C1.51434 11.0093 1.76573 10.8732 2.03992 10.8406L2.16667 10.833H5.41667Z"
          fill={disabled ? "transparent" : "white"}
          stroke={disabled ? "rgba(0, 0, 0, 0.60)" : "#006CDD"}
          stroke-width="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_9570_143041">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SaveAndSendSvg;
